import gql from 'graphql-tag';

export const getCheckoutPriceQuery = gql`
  query getCheckoutPrice(
    $account_id: RecordID
    $address_id: RecordID
    $subscription_items: [CheckoutSubscriptionItem]
    $custom_print_items: [CheckoutCustomPrintItem]
    $photo_items: [CheckoutPhotoItem]
    $photo_print_items: [CheckoutPhotoPrintItem]
    $photo_download_items: [CheckoutPhotoDownloadItem]
    $search_subscription_items: [CheckoutSearchSubscriptionItem]
    $digital_bundle_items: [CheckoutDigitalBundleItem!]
    $print_order_service_items: [CheckoutPrintOrderServiceItem!]
    $print_partner_shipping_option_id: RecordID
    $promo_code: String
  ) {
    checkoutPrice(
      account_id: $account_id
      account_address_id: $address_id
      subscription_items: $subscription_items
      custom_print_items: $custom_print_items
      photo_items: $photo_items
      photo_print_items: $photo_print_items
      photo_download_items: $photo_download_items
      search_subscription_items: $search_subscription_items
      digital_bundle_items: $digital_bundle_items
      print_order_service_items: $print_order_service_items
      print_partner_shipping_option_id: $print_partner_shipping_option_id
      promo_code: $promo_code
    ) {
      total_price {
        value
        currency
      }
      total_shipping_cost {
        value
        currency
      }
      total_tax {
        value
        currency
      }
      subscriptions_total_price {
        value
        currency
      }
      custom_prints_total_price {
        value
        currency
      }
      custom_prints_shipping_cost {
        value
        currency
      }
      items_price_breakdown {
        photo_items {
          checkout_item_client_id
          price {
            value
            currency
          }
          discount_price {
            value
            currency
          }
        }
      }
      requires_payment
    }
  }
`;
